export enum InspectionStatus {
  Created = 10,
  Started = 12,
  Loaded = 15,
  RequirementsFulfilled = 20,
  Weighed = 25,
  Signed = 28,
  Cancelled = 40,
  MissingSeparatorData = 50,
  Unknown = -1,
}

export const inspectionStatusLabel = (status: InspectionStatus) => {
  switch (status) {
    case InspectionStatus.Created:
      return "Skapad";
    case InspectionStatus.RequirementsFulfilled:
      return "Klar";
    case InspectionStatus.Cancelled:
      return "Avbruten";
    case InspectionStatus.MissingSeparatorData:
      return "Saknar objektdata";
    case InspectionStatus.Started:
      return "Påbörjad";
    default:
      throw Error(
        "inspectionStatusLabel missing implementation for " + status.toString(),
      );
  }
};

// Ta bort org nr obligatoriskt

// när man lägger till ny rapport, välj
